import { COUNTRY } from "./app";
import { IMAGE_URL_CONFIG, URLS } from "./url";

export const timezoneConfig: Record<string, string[]> = {
    [COUNTRY.AUS]: [
      "Australia/Sydney",
      "Australia/Melbourne",
      "Australia/Brisbane",
      "Australia/Perth",
      "Australia/Adelaide",
      "Australia/Darwin",
      "Australia/Hobart",
      "Australia/Lindeman",
      "Australia/Broken_Hill",
      "Australia/Lord_Howe"
    ],
    [COUNTRY.NZ]: [
      "Pacific/Auckland",
      "Pacific/Chatham"
    ],
    [COUNTRY.US]: [
        "America/New_York",
        "America/Detroit",
        "America/Kentucky/Louisville",
        "America/Kentucky/Monticello",
        "America/Indiana/Indianapolis",
        "America/Indiana/Marengo",
        "America/Indiana/Knox",
        "America/Indiana/Petersburg",
        "America/Indiana/Vevay",
        "America/Indiana/Vincennes",
        "America/Indiana/Winamac",
        "America/Chicago",
        "America/Indiana/Tell_City",
        "America/Menominee",
        "America/North_Dakota/Center",
        "America/North_Dakota/New_Salem",
        "America/North_Dakota/Beulah",
        "America/Denver",
        "America/Boise",
        "America/Phoenix",
        "America/Los_Angeles",
        "America/Anchorage",
        "America/Juneau",
        "America/Sitka",
        "America/Yakutat",
        "America/Nome",
        "America/Adak",
        "Pacific/Honolulu"     
      ]
  };

  export const ALLOWED_REGIONS  = [COUNTRY.US, COUNTRY.NZ, COUNTRY.AUS];

  export const regionDetection: any = {
    [COUNTRY.US]: {
      title: "It looks like you’re visiting our ###COUNTRY### site from the United States.",
      question: "Would you like to go to our United States site instead?",
      flagTitle: "Go to United States website",
      flagURL: IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + "flag_us.svg",
      redirectLink: URLS.READINGCINEMAS_US_SITE,
    },
    [COUNTRY.NZ]: {
      title: "It looks like you’re visiting our ###COUNTRY### site from New Zealand.",
      question: "Would you like to go to our New Zealand site instead?",
      flagTitle: "Go to New Zealand website",
      flagURL: IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + "flag_nz.svg",
      redirectLink: URLS.READINGCINEMAS_NZ_SITE,
    },
     [COUNTRY.AUS]: {
      title: "It looks like you’re visiting our ###COUNTRY### site from Australia.",
      question: "Would you like to go to our Australian site instead?",
      flagTitle: "Go to Australian website",
      flagURL: IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + "flag_au.svg",
      redirectLink: URLS.READINGCINEMAS_AU_SITE,
    }
  }

   export const regionDetectionCountry: any = {
    [COUNTRY.AUS]: {
      name:'Australian',
      continueToFlag: IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + "flag_au.svg",
      continueToTitle: "Continue to Australian website"
    },
     [COUNTRY.NZ]: {
      name:'New Zealand',
      continueToFlag: IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + "flag_nz.svg",
      continueToTitle: "Continue to New Zealand website"
    }
   }